import React from 'react';
import { useParams } from 'react-router-dom';

import WalkInPage from 'components/walkInPage';
import { useEventManipulate } from './v2/useEventManipulate';

import 'styles/scss/routes/event.scss';

export default function WalkIn(props) {
  const params = useParams();
  const { title, customStyle } = useEventManipulate(props);

  return (
    <main className="event-page" style={customStyle}>
      <WalkInPage eventId={params.eventId} eventTitle={title()}></WalkInPage>
    </main>
  );
}
